import type { MedicalHistoryConfig } from 'config-types/config/medical-history';

const MEDICAL_HISTORY_DATA: MedicalHistoryConfig = {
  medicalConditions: {
    quickPicks: [
      { display: 'Arthritis' },
      { display: 'Blood Disorder' },
      { display: 'Cancer' },
      { display: 'Diabetes' },
      { display: 'Gastrointestinal' },
      { display: 'Genitourinary' },
      { display: 'Heart Disorders' },
      { display: 'High Blood Pressure' },
      { display: 'High Cholesterol' },
      { display: 'Kidney Disorders' },
      { display: 'Liver Disorders, Hepatitis' },
      { display: 'Lung Disorders' },
      { display: 'Musculoskeletal Diseases' },
      { display: 'Neurological' },
      { display: 'Psychiatric' },
      { display: 'Sexually Transmitted Diseases' },
      { display: 'Skin Disorders' },
      { display: 'Thyroid' },
      { display: 'Diabetes type 2', code: 'E11.9' },
      { display: 'Diabetes Type 1', code: 'E10.9' },
      { display: 'High Blood pressure', code: 'i10' },
      { display: 'Heart Disease', code: 'I51.9' },
      { display: 'Elevated Cholesterol', code: 'E78.5' },
      { display: 'Asthma', code: 'J45.909' },
      { display: 'COPD', code: 'J44.9' },
      { display: 'Back Pain', code: 'M54.50' },
      { display: 'HypoThyroid', code: 'E03.9' },
      { display: 'Gout', code: 'M10.9' },
      { display: 'Arthritis', code: 'M19.90' },
    ],
  },
  allergies: {
    quickPicks: [],
  },
  medications: {
    quickPicks: [
      { name: 'Toradol', strength: '60 mg', id: 10098 },
      { name: 'Toradol', strength: '30 mg', id: 81146 },
      { name: 'Decadron', strength: '8 mg', id: 39039 },
      { name: 'Decadron', strength: '4 mg', id: 39038 },
      { name: 'Rocephin', strength: '1 g', id: 30900 },
      { name: 'Rocephin', strength: '500 mg', id: 30901 },
    ],
  },
  inHouseMedications: {
    quickPicks: [
      { name: 'Acetaminophen 500mg', dose: 500, units: 'mg', route: '26643006', ndc: '57896-0219-01' },
      { name: 'Aspirin 325mg', dose: 325, units: 'mg', route: '26643006', ndc: '68599-1311-03' },
      { name: 'Ceftriaxone 1gm', dose: 1, units: 'g', route: '78421000', ndc: '44567-0701-25' },
      { name: 'Ceftriaxone 500mg', dose: 500, units: 'mg', route: '78421000', ndc: '0409-7338-11' },
      { name: 'Clonidine 0.1mg', dose: 0.1, units: 'mg', route: '26643006', ndc: '00228-2127-10' },
      { name: 'Cyanocobalamin', dose: 1, units: 'mg', route: '78421000', ndc: '0517-0130-01' },
      { name: 'Dexamethasone', dose: 5, units: 'mg', route: '78421000', ndc: '67457-0420-00' },
      { name: 'Dexamethasone', dose: 10, units: 'mg', route: '78421000', ndc: '67457-0420-00' },
      { name: 'Diphenhydramine', dose: 25, units: 'mg', route: '78421000', ndc: '00641-0376-21' },
      { name: 'Diphenhydramine', dose: 50, units: 'mg', route: '78421000', ndc: '00641-0376-21' },
      { name: 'Ketorolac 30mg', dose: 30, units: 'mg', route: '78421000', ndc: '72266-0118-01' },
      { name: 'Ketorolac 60mg', dose: 60, units: 'mg', route: '78421000', ndc: '63323-0162-03' },
      { name: 'Nitrostat 0.4mg', dose: 0.4, units: 'mg', route: '26643006', ndc: '51662-1282-03' },
      { name: 'Ondansetron', dose: 2, units: 'mg', route: '78421000', ndc: '60505-6130-00' },
      { name: 'Ondansetron', dose: 4, units: 'mg', route: '78421000', ndc: '60505-6130-00' },
      { name: 'Ondansetron', dose: 8, units: 'mg', route: '78421000', ndc: '60505-6130-00' },
      { name: 'Ondansetron 4mg', dose: 4, units: 'mg', route: '26643006', ndc: '16714-0200-30' },
      { name: 'Ondansetron 4mg', dose: 8, units: 'mg', route: '26643006', ndc: '16714-0200-30' },
      { name: 'Promethazine', dose: 25, units: 'mg', route: '78421000', ndc: '00641-0928-21' },
    ],
  },
};

export const MEDICAL_HISTORY_CONFIG = Object.freeze(MEDICAL_HISTORY_DATA);
